/**
 * Online UI API
 * # Summary Elisa B2B Online UI API  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Authentication error enum
 */
export type ValidationConflict = 'ADDITIONAL_INFO_REQUIRED' | 'ADDITIONAL_INFO_REQUIRED_FOR_INVITATION' | 'CHOOSE_SIGNATORY_RIGHT' | 'CHOOSE_ADMIN_OR_SIGNATORY_RIGHT' | 'INDIVIDUAL_NOT_STRONGLY_IDENTIFIED';

export const ValidationConflict = {
    ADDITIONAL_INFO_REQUIRED: 'ADDITIONAL_INFO_REQUIRED' as ValidationConflict,
    ADDITIONAL_INFO_REQUIRED_FOR_INVITATION: 'ADDITIONAL_INFO_REQUIRED_FOR_INVITATION' as ValidationConflict,
    CHOOSE_SIGNATORY_RIGHT: 'CHOOSE_SIGNATORY_RIGHT' as ValidationConflict,
    CHOOSE_ADMIN_OR_SIGNATORY_RIGHT: 'CHOOSE_ADMIN_OR_SIGNATORY_RIGHT' as ValidationConflict,
    INDIVIDUAL_NOT_STRONGLY_IDENTIFIED: 'INDIVIDUAL_NOT_STRONGLY_IDENTIFIED' as ValidationConflict
};

